// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__10Rlk","name":"ConsentHeader_name___eByX","birthday":"ConsentHeader_birthday__GlwVV","skeleton":"ConsentHeader_skeleton__1XdV8"};